
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorPointingHandIcon as ObiCursorPointingHandIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-pointing-hand-icon.js';
 
 
 

 
 export const ObiCursorPointingHandIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-pointing-hand-icon',
   elementClass: ObiCursorPointingHandIconElement,
   events: {
     
   }
  });
 
 